import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { Center, Loader } from '@mantine/core'
import { FaxInbox } from '@/components/fax'

export function FaxInboxPage() {
  return (
    <div className="flex size-full flex-auto flex-col">
      <div className="flex size-full flex-auto">
        <div
          id="fax-inbox-scroll"
          className="max-h-[calc(100vh-64px)] w-xs flex-none overflow-y-auto border-r border-gray-200"
        >
          <Suspense
            fallback={
              <Center className="size-full">
                <Loader />
              </Center>
            }
          >
            <FaxInbox />
          </Suspense>
        </div>
        <div className="flex-auto">
          <Suspense
            fallback={
              <Center className="size-full">
                <Loader />
              </Center>
            }
          >
            <Outlet />
          </Suspense>
        </div>
      </div>
    </div>
  )
}
